<template>
	<div class="mb-4 notification_registry" style="justify-content:space-between">
		<div class="flex-row">
			<label class="page-label">Добавить уведомление</label>
		</div>
	</div>
	<div class="notification_registry__input">
		<div class="mb-4">
			<label for="exampleFormControlInput1" class="form-label">Заголовок уведомления</label>
			<input type="text" class="form-control" placeholder="Введите ссылку">
		</div>
		<div class="mb-4 form-check" >
            <input class="form-check-input" type="checkbox" value="" id="importantToggle" @click="importantToggle">
            <label class="form-check-label">
                Это важное уведомление
            </label>
        </div>
		<div class="mb-4"
		     v-if="isImportant">
			<label for="exampleFormControlInput3" class="form-label">Дата и время отправки</label>
			<input type="datetime-local" class="form-control" id="exampleFormControlInput3" placeholder="Placeholder">
		</div>
	</div>
	<TinyMCE
            api-key="313bsfiddi7yzx1ip6g4i5mu8da22nvsjz3otml293i6eor0"
            :init="{
                language: 'ru',
				plugins: ['image', 'autoresize', 'code', 'media', 'autolink', 'table', 'lists'],
				images_upload_handler: uploadFunction,
				toolbar1: 'newdocument | insertfile undo redo | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | cut copy paste | numlist bullist outdent indent | image media| code| table styleselect formatselect fontselect fontsizeselect | responsivefilemanager | blockqote | removeformat',
				toolbar_mode: 'wrap',
				toolbar_sticky: false,
				min_height: 400,
				image_advtab: true,
				file_picker_types: 'file image media',
				default_link_target: '_blank',
				link_context_toolbar: true,
				relative_urls: false,
				remove_script_host: false,
				link_title: false,
			}"
            v-model="content"
        />
		<div class="mt-4 notification_registry__input">
			<div class="notification_registry__buttons">
				<button type="button" class="btn btn-lg btn-primary">
					Сохранить
				</button>
				<button type="button" class="btn btn-lg btn-outline-dark" data-bs-dismiss="modal">
					Отменить
				</button>
			</div>
		</div>
</template>

<script>
import TinyMCE from '@tinymce/tinymce-vue';

export default {
    name: 'NotificationAddComponent',
    components: {
		TinyMCE
	},
	props: {},
	data() {
		return {
			isImportant: false,
			content: ''
		};
	},
	computed: {
		
	},
	methods: {
		importantToggle: function () {
			this.isImportant = !this.isImportant;
		},
		uploadFunction:  function(blobInfo, success, failure) {
            return new Promise((resolve, reject) => {
                const FormRequest = new FormData();
                FormRequest.append('image', blobInfo.blob());
                let imgUrl = null;
                axios.post('/technical/letter-constructor/upload', FormRequest).then((res) => {
                    if(res.data.status == 'ok') {
                        imgUrl = res.data.url;
                        resolve(imgUrl);
                    }
                });
            })
        },
	},
	mounted() {
	}
};
</script>

<style scoped lang="scss">
	.page-label {
		font-size: 18px;
		font-weight: 600;
	}
	.notification_registry {
		&__input {
			display: flex;
			flex-direction: column;
			max-width: 400px;
		}
		&__buttons {
			display: flex;
			padding: 0;
			gap: 12px;
			.btn {
				flex-grow: 1;
			}
		}
	}
	.pointer {
		cursor: pointer;
	}
</style>
